import { styled } from '@mui/material/styles';
import { PolicyStreamCard } from './components';

export const PolicyStreamContentCard = styled(PolicyStreamCard)(
  ({ theme }) => ({
    color: theme.palette.secondary.contrastText,
    border: `1px solid ${theme.palette.secondary.dark}`,
    backgroundColor: theme.palette.secondary.main,
    borderRadius: theme.spacing(2),
    boxShadow: 'none',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(3),
    gap: theme.spacing(8),
    [theme.breakpoints.down('md')]: {
      gap: theme.spacing(2),
      flexDirection: 'column',
      justifyContent: 'left',
      alignItems: 'flex-start',
    },
  }),
);
